import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const detail = {
  title: '斩江咒',
  content: [
    '江神退位，<br />水怪潜形，',
    '吾今执令，<br />敢有违者，',
    '斩妖除魔，<br />镇宅安宁。'
  ],
  description: '斩江咒为道家镇宅护平安之要咒，用于驱除宅内邪秽之物。',
  usage: [
    '新居入伙前诵读三遍',
    '家中不安时每日晨起诵读',
    '农历每月初一日效果最佳',
    '配合符箓使用效果更佳'
  ]
};

const FuzouDetail = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-red-50 to-rose-50 flex flex-col">
      <div className="flex-grow flex flex-col items-center py-12 px-4">
        <div className="w-full max-w-4xl">
          <button
            onClick={() => navigate('/fuzou')}
            className="flex items-center text-red-800 mb-8 hover:text-red-600 transition-colors"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            返回符咒列表
          </button>

          <div className="bg-white rounded-2xl shadow-xl border-2 border-red-200 overflow-hidden">
            <div className="bg-gradient-to-r from-red-500 to-rose-500 py-6 text-center">
              <h1 className="text-3xl font-bold text-white font-serif tracking-widest">
                {detail.title}
              </h1>
            </div>

            <div className="p-8">
              <p className="text-gray-600 mb-8 italic text-center">
                镇宅护平安
              </p>

              <div className="space-y-4 text-xl sm:text-2xl font-medium text-gray-800 leading-relaxed font-serif text-center mb-10">
                {detail.content.map((line, index) => (
                  <p key={index} dangerouslySetInnerHTML={{ __html: line }}></p>
                ))}
              </div>

              <div className="space-y-6">
                <div className="bg-red-50 rounded-xl p-6 border border-red-100">
                  <h3 className="text-lg font-bold text-red-900 mb-3">咒语说明</h3>
                  <p className="text-gray-700">{detail.description}</p>
                </div>

                <div className="bg-red-50 rounded-xl p-6 border border-red-100">
                  <h3 className="text-lg font-bold text-red-900 mb-3">使用方法</h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-700">
                    {detail.usage.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FuzouDetail;
